const Environment = {
    production: (window._env_.REACT_APP_PRODUCTION === 'true'),
    //production: false,
    api: window._env_.REACT_APP_API,
    //api: 'http://192.168.106.248:8100/',
    statics: window._env_.REACT_APP_STATICS
}

// const Environment = {
// 	production: false,
// 	validate_email: false,
//     api: 'http://54.81.117.244:8000/'
// }

// const Environment = {
// 	  production: true,
// 	  validate_email: true,
//       api: 'http://192.168.1.108:8009/'
// }

export default Environment;


